import { faChevronLeft, faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Flex, Button } from 'antd';
import './Nav.sass';

interface NavProps {
	options: Array<any>;
	index: number;
	count: number;
	fullWidth: boolean;
	onSelect?: (option: any) => void;
	children: any;
}

const Nav = (props: NavProps) => (
	<div style={{ textAlign: 'center' }} className="Navigation noselection w-100 text-center">
		<Flex align="center" justify="center" className="w-100">


			<Button
				onClick={() => {
					props.onSelect && props.onSelect(props.index - 1 >= 0 ? props.index - 1 : props.count - 1);
				}}
				className="action"
				style={{ marginRight: '1rem' }}
			>
				<FontAwesomeIcon icon={faChevronLeft} />
			</Button>

			<div className={props.fullWidth ? 'w-100 text-center' : 'text-center'}>{props.children}</div>

			<Button
				onClick={() => {
					props.onSelect && props.onSelect(Math.max(props.index + 1, 0));
				}}
				className="action"
				style={{ marginLeft: '1rem' }}
			>
				<FontAwesomeIcon icon={faChevronRight} />
			</Button>


		</Flex>
	</div >
);

export default Nav;